import template from './sw-cms-block-text-hero.html.twig';
import './sw-cms-block-text-hero.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
